import React from 'react'
import classes from "./BlackModalBg.module.css"

interface bgProps {
  children ?: any
}

const BlackModalBg:React.FC<bgProps> = ({children }) => {
  return (
   <div  className={classes["modal-root"]}>
      {children}
    </div>
  )
}

export default BlackModalBg